"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CotDataGraphToProjectUtil = void 0;
const CotTemplateResponseData_1 = require("../cot/typed/CotTemplateResponseData");
const CotUtil_1 = require("../cot/CotUtil");
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
const FunctionsConfig_1 = require("../../base/project/config/FunctionsConfig");
const CotConstant_1 = require("../cot/CotConstant");
const offsetDistance = 300;
class CotDataGraphToProjectUtil {
    /**
     * TODO: 返回类型还不是真正意义上面的class，只是一个object。
     * 返回project
     * @param input
     * @param flow
     * @param extraSaasUIData
     * @param nodeInitData
     * @param edgeNodeInitData
     * @param lineInitData
     */
    static generateTemplateProject(input, flow, extraSaasUIData, nodeInitData, edgeNodeInitData, lineInitData) {
        const responseData = this.transformTemplate(input, flow, extraSaasUIData, nodeInitData, edgeNodeInitData, lineInitData);
        const project = this.transformResponseToTemplateProject(responseData, input);
        return project;
    }
    static transformTemplate(input, flow, extraSaasUIData, nodeInitData, edgeNodeInitData, lineInitData) {
        const inputs = this.createInputNodes(flow.graph.nodes, nodeInitData);
        const saasInputNodeIds = inputs.map(node => node.id);
        const previewData = this.createPreviewData(flow.graph.nodes, input);
        const { edgeMap, nodeMap, outputs } = this.groupMapByTarget(flow, nodeInitData);
        const { saasNodes, saasEdges, orderMap } = this.generateNodesAndEdges(edgeMap, nodeMap, CotUtil_1.CotUtil.getMaxIndexByFlow(flow), edgeNodeInitData, lineInitData);
        const flowGroup = this.createFlowGroup(flow.action_sequence, orderMap);
        const result = {
            inputs,
            outputs,
            flowGroup,
            previewData,
            extraSaasUIData,
            saasInputNodeIds,
            edges: saasEdges,
            otherNodes: saasNodes,
            nodes: [...inputs, ...saasNodes],
        };
        /* const result = JsonUtil.toModelFromInstance(TransformResponseData, {
          inputs,
          outputs,
          flowGroup,
          previewData,
          extraSaasUIData,
          saasInputNodeIds,
          edges: saasEdges,
          otherNodes: saasNodes,
          nodes: [...inputs, ...saasNodes],
        }) as TransformResponseData; */
        return result;
    }
    static transformResponseToTemplateProject(data, query) {
        const templateObject = {
            template_name: "Untitled",
            name: "Untitled",
            description: "",
            lastIndex: 1,
            v3: {
                edges: data.edges,
                nodes: data.nodes,
                showToolTipStatus: "init",
                nodeIndex: 15,
                edgeIndex: 4,
                autoImagica: {
                    query,
                },
                version: 1,
                functions: [],
                UI: [
                    {
                        label: "",
                        value: "saas",
                        title: data.extraSaasUIData?.title || CotConstant_1.CotConstant.webAppDefaultTitle,
                        titleV3: {},
                        // cal api
                        subTitle: data.extraSaasUIData?.subTitle || CotConstant_1.CotConstant.webAppDefaultSubTitle,
                        subTitleV3: {},
                        placeholder: "Enter something",
                        input: data.inputs,
                        output: data.outputs,
                        showTitle: true,
                        showSubTitle: true,
                        titleStyle: "{}",
                        subTitleStyle: "{}",
                        staticMode: false,
                        settings: {
                            branding: true,
                            width: 800,
                            height: 600,
                        },
                        theme: "light",
                        fontSize: 12,
                        id: "appId-1",
                        v2App: {
                            id: "appId-1",
                            type: "ai_app",
                            appName: "My AI App",
                            appDescription: "",
                        },
                    },
                ],
                previewAppId: "appId-1",
            },
            published_metadata: {
                uuid: "",
                original: true,
                stripe_product_id: "",
                stripe_price_id: "",
                stripe_account_id: "",
            },
        };
        return templateObject;
    }
    static generateNodesAndEdges(edgeMap, nodeMap, startNodeIndex, edgeNodeInitData, lineInitData) {
        const saasNodes = [];
        const saasEdges = [];
        const orderMap = new Map();
        for (let [targetId, sourceEdges] of edgeMap.entries()) {
            const targetNode = nodeMap.get(targetId);
            if (targetNode) {
                const description = targetNode.data.placeholder ?? "";
                const functionType = targetNode.data.functionType;
                let textAreaValue = this.getFunctionNameByEnterText(description, functionType);
                if ((0, is_blank_1.default)(textAreaValue)) {
                    // 如果匹配不到就默认为text并显示unsupported.
                    nodeMap.set(targetId, {
                        ...targetNode,
                        data: {
                            ...targetNode.data,
                            showWarning: true,
                        },
                    });
                    textAreaValue = description;
                }
                const { lines, edgeNode } = this.createSingleFlow(targetNode, textAreaValue, startNodeIndex, sourceEdges, nodeMap, edgeNodeInitData, lineInitData);
                startNodeIndex += sourceEdges.length + 2;
                saasNodes.push(edgeNode);
                saasNodes.push(targetNode);
                saasEdges.push(...lines);
                orderMap.set(targetId, {
                    edges: lines,
                    node: targetNode,
                    edgeNode: edgeNode,
                });
            }
        }
        return { saasNodes, saasEdges, orderMap };
    }
    static groupMapByTarget(flow, nodeInitData) {
        const outputs = [];
        const nodeMap = new Map();
        const edgeMap = new Map();
        const others = this.getNotInputNodes(flow.graph.nodes);
        others.forEach((node, index) => {
            const canvasNode = CotUtil_1.CotUtil.createNode(node, nodeInitData);
            nodeMap.set(canvasNode.id, canvasNode);
            outputs.push(CotUtil_1.CotUtil.createOutput(canvasNode));
        });
        // 把边按照target分组
        flow.graph.edges.forEach(edge => {
            const targetNodeId = nodeMap.get(`group-${edge.target}`) ? `group-${edge.target}` : `editor-${edge.target}`;
            edgeMap.set(targetNodeId, (edgeMap.get(targetNodeId) ?? []).concat(edge));
        });
        return {
            edgeMap,
            nodeMap,
            outputs,
        };
    }
    static createSingleFlow(targetNode, textAreaValue, startNodeIndex, sourceEdges, nodeMap, edgeNodeInitData, lineInitData) {
        const targetId = targetNode.id;
        const newEdgeNumber = startNodeIndex++;
        const newEdgeId = `new-edge-${newEdgeNumber}`;
        const edges = sourceEdges.map(edge => {
            const prefix = nodeMap.get(`group-${edge.source}`) ? `group` : `editor`;
            return {
                textAreaValue,
                id: `new-line-${edge.id}`,
                source: `${prefix}-${edge.source}`,
                edgeNodeId: newEdgeId,
            };
        });
        const flows = edges.map((edge, index) => ({
            sourceNodeId: edge.source,
            sourceLineId: edge.id,
            creationMethod: index === 0,
        }));
        // 创建EdgeNode
        const targetLineId = startNodeIndex++;
        const edgeNode = CotUtil_1.CotUtil.createEdgeNode({
            flows,
            targetId,
            id: newEdgeId,
            enterText: textAreaValue,
            position: {
                x: (targetNode.position?.x ?? 0) - offsetDistance,
                y: targetNode.position?.y ?? 0,
            },
            targetLineId: `new-line-${targetLineId}-${targetId}`,
        }, edgeNodeInitData);
        // targetLine
        edges.push({
            textAreaValue,
            id: `new-line-${targetLineId}-${targetId}`,
            source: newEdgeId,
            edgeNodeId: targetId,
        });
        const lines = edges.map(item => CotUtil_1.CotUtil.createLine(item, lineInitData, item.source !== newEdgeId));
        return { lines, edgeNode };
    }
    static createInputNodes(nodes, nodeInitData) {
        const inputs = this.getInputNodes(nodes);
        return inputs.map(node => CotUtil_1.CotUtil.createNode(node, nodeInitData));
    }
    static createFlowGroup(sequence, orderMap) {
        const nodeOrders = sequence.filter(([type]) => type === "node").map(([, id]) => id);
        return nodeOrders
            .map(id => orderMap.get(`editor-${id}`) ?? orderMap.get(`group-${id}`) ?? null)
            .filter(item => (0, is_blank_1.default)(item) === false);
    }
    static createPreviewData(nodes, input) {
        const inputs = this.getInputNodes(nodes);
        const others = this.getNotInputNodes(nodes);
        return {
            input: inputs.map(node => node.id),
            output: others.map(node => node.id),
            templateValue: input,
        };
    }
    /// 根据function_type转译边上的文字
    static getFunctionNameByEnterText(description, functionType) {
        const allFunctions = FunctionsConfig_1.preDefinedGlobalFunctions.concat(FunctionsConfig_1.defaultApis);
        const functionName = (allFunctions.find(x => x.aliases?.includes(functionType)) || {}).label || functionType;
        if (!(0, is_blank_1.default)(functionType) && functionType !== "Text Generation") {
            if (functionName) {
                return `/${functionName}`;
            }
            return undefined;
        }
        return description;
    }
    /// 获取所有的input node
    static getInputNodes(nodes) {
        return nodes.filter(node => node.type === CotTemplateResponseData_1.NodeType.USERINPUT);
    }
    /// 获取所有的非input node
    static getNotInputNodes(nodes) {
        return nodes.filter(node => node.type !== CotTemplateResponseData_1.NodeType.CONNECTION && node.type !== CotTemplateResponseData_1.NodeType.INTERACTION && node.type !== CotTemplateResponseData_1.NodeType.USERINPUT);
    }
}
exports.CotDataGraphToProjectUtil = CotDataGraphToProjectUtil;
